<template>
  <div
    class="relative min-h-screen h-full mx-auto"
  >
    <AppHeader v-if="hasHeader" />

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import AppHeader from './Header.vue'

export default {
  components: {
    AppHeader
  },

  computed: {
    hasHeader () {
      return this.$route.name !== '404' && this.$route.name !== 'home'
    }
  }
}
</script>
